import * as React from 'react';
import {ChapterContentObject, ChapterObject} from 'api/course';
import ContentElement from './ContentElement';

export interface RenderContentElementsProps {
  content: ChapterContentObject[];
  chapterId: ChapterObject['id'];
}

/**
 * This component pure render the content elements.
 */
export default class RenderContentElements
  extends React.Component<RenderContentElementsProps> {
  /**
   * Configure.
   * @param {RenderContentElementsProps} props
   */
  constructor(props: RenderContentElementsProps) {
    super(props);
  }

  /**
   * shouldComponentUpdate
   * @param {Readonly<RenderContentElementsProps>} nextProps
   * @return {boolean}
   */
  shouldComponentUpdate(
      nextProps: Readonly<RenderContentElementsProps>,
  ): boolean {
    return nextProps !== this.props;
  }

  /**
   * Render.
   * @return {JSX.Element}
   */
  render() {
    return this.props.content.map((content, index) => (
      <ContentElement
        key={content.id}
        index={index}
        chapterId={this.props.chapterId}
        {...content}
      />
    ));
  }
}
